import React from "react";

const headerStyles = `
:root{
  --app-header-height:72px;
  --hdr-bg-1:#0b1736;
  --hdr-bg-2:#0f2a66;
  --hdr-text:#eef2ff;
  --muted:#c7d2fe;
  --accent:#60a5fa;
  --glass: rgba(255,255,255,0.04);
}

.app-header{
  width:100%; 
  position:fixed; 
  top:0; left:0; right:0; 
  /* Use min-height to allow expansion on high zoom */
  min-height:var(--app-header-height); 
  z-index:120;
  background: linear-gradient(90deg,var(--hdr-bg-1),var(--hdr-bg-2));
  box-shadow: 0 8px 30px rgba(23, 38, 86, 0.35);
  color:var(--hdr-text);
  box-sizing: border-box;
}

.app-header-inner{ 
  max-width:1200px; 
  margin:0 auto; 
  padding: 12px 24px; 
  display:flex; 
  flex-wrap: wrap; /* Allows wrapping on zoom */
  align-items:center; 
  justify-content:space-between; 
  gap:16px; 
}

.brand{ display:flex; align-items:center; gap:14px; flex:0 0 auto; text-decoration: none; }
.brand img{ width:40px; height:40px; object-fit:contain; border-radius:8px; background:rgba(255,255,255,0.06); padding:6px; }
.brand-title{ font-weight:700; color:var(--hdr-text); font-size:1.05rem; display:flex; align-items:center; gap:8px }
.brand-title .highlight{ color:var(--accent); }

.flow{ 
  flex:1 1 auto; 
  display: flex; 
  justify-content: center; 
}

.flow-steps{ 
  display:inline-flex; 
  align-items:center; 
  gap:12px; 
  background:rgba(255,255,255,0.04); 
  padding:8px 14px; 
  border-radius:12px; 
}

.flow-step{ 
  padding:6px 10px; 
  border-radius:8px; 
  color:var(--muted); 
  font-weight:700; 
  font-size:0.9rem; 
  letter-spacing:0.2px; 
  transition: all 150ms ease; 
  white-space: nowrap;
}

.flow-step.active{
  color: var(--hdr-text);
  background: rgba(255,255,255,0.18);
  border: 1px solid rgba(255,255,255,0.18);
  box-shadow: 0 10px 26px rgba(2,6,23,0.30);
  transform: translateY(-2px);
}
.flow-sep{ color: rgba(255,255,255,0.16); font-weight:700 }

.actions{ display:flex; gap:12px; align-items:center; flex: 0 0 auto; }

.logout-btn{
  background: transparent;
  border: 1px solid rgba(255,255,255,0.12);
  padding: 6px 12px;
  min-height: 36px;
  min-width: 80px;
  border-radius: 16px;
  cursor: pointer;
  color: var(--hdr-text);
  font-weight: 600;
  font-size: 0.9rem;
  line-height: 1;
  transition: background 160ms ease, transform 120ms ease, box-shadow 160ms ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 14px rgba(2,6,23,0.12);
}
.logout-btn:hover{ background: rgba(255,255,255,0.06); transform: translateY(-2px); box-shadow: 0 10px 24px rgba(2,6,23,0.14); }

.logout-btn.danger{ background: #c62828; border:1px solid rgba(255,255,255,0.22); color:#fff; box-shadow: 0 8px 20px rgba(198,40,40,0.18); }
.logout-btn.danger:hover{ transform: translateY(-2px) scale(1.02); box-shadow: 0 12px 32px rgba(198,40,40,0.24); }

/* Ensure page content isn't hidden behind fixed header */
body{ padding-top: var(--app-header-height); }

/* RESPONSIVE & ZOOM HANDLING */
@media (max-width: 900px) { 
  .app-header-inner { padding: 12px 16px; } 
  .flow-step { font-size: 0.8rem; padding: 4px 8px; }
}

@media (max-width: 768px) { 
  /* Hide the middle steps section on mobile or high zoom to prevent overlap */
  .flow { display: none; } 
  .app-header-inner { justify-content: space-between; }
}
`;

const Header = ({ onLogout, active }) => {
  const doLogout = () => {
    if (typeof onLogout === "function") {
      onLogout();
      return;
    }
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch (e) {}
    if (window && window.location) window.location.href = "/login";
  };

  return (
    <header className="app-header">
      <style>{headerStyles}</style>
      <div className="app-header-inner">
        <div className="brand">
          <img
            src="/logo.png"
            alt="Logo"
            style={{ width: 36, height: 36, objectFit: "contain" }}
          />
          <div className="brand-title">
            <span className="highlight">Prior Art</span> Report Generator
          </div>
        </div>

        <div className="flow">
          <div className="flow-steps" role="tablist" aria-label="Flow steps">
            <div
              className={"flow-step" + (active === "metadata" ? " active" : "")}
            >
              Metadata
            </div>
            <div className="flow-sep">›</div>
            <div
              className={"flow-step" + (active === "priorArt" ? " active" : "")}
            >
              Prior Art
            </div>
            <div className="flow-sep">›</div>
            <div
              className={"flow-step" + (active === "download" ? " active" : "")}
            >
              Download
            </div>
          </div>
        </div>

        <div className="actions">
          <button
            className="logout-btn danger"
            onClick={doLogout}
            aria-label="Logout"
          >
            <span>Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
